import { render, staticRenderFns } from "./EmailTeacher.vue?vue&type=template&id=3a4067b1"
import script from "./EmailTeacher.vue?vue&type=script&lang=js"
export * from "./EmailTeacher.vue?vue&type=script&lang=js"
import style0 from "./EmailTeacher.vue?vue&type=style&index=0&id=3a4067b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports